import React from "react";
import { OAuthIDP } from "../../hooks/useOAuth";
import { Button } from "semantic-ui-react";

export enum AuthMode {
  Login = "Sign in",
  Register = "Sign up",
}

export function SSOButton({
  idp,
  initiateOAuth,
  mode,
  isLoading,
  masquerade,
}: {
  idp: OAuthIDP;
  initiateOAuth: (idp: OAuthIDP, masquerade?: string) => void;
  mode: AuthMode;
  isLoading?: boolean;
  masquerade?: string;
}) {
  return (
    <Button
      className='tw-mt-2 tw-flex tw-h-12 tw-items-center tw-justify-center tw-rounded-none tw-border-[1px]
                tw-border-solid tw-border-[#8C8C8C] tw-bg-white tw-p-3 tw-font-medium tw-text-[#5E5E5E]'
      type='button'
      fluid
      primary
      size='large'
      onClick={() => initiateOAuth(idp, masquerade)}
      disabled={isLoading}
    >
      <img className='tw-mx-3' src={`/assets/integrations/${idp} Logo.svg`} alt={`${idp} Logo`} />
      {mode} with {idp}
    </Button>
  );
}
